import gql from 'graphql-tag';

export const schema = gql`
  mutation CreatePropertyListingPublication($tags: [ResourceTagInput]) {
    createPropertyListingPublication(tags: $tags) {
      __typename
      ... on CreatePropertyListingPublicationFailure {
        error {
          code
          message
          metadata {
            key
            value
          }
        }
      }

      ... on CreatePropertyListingPublicationSuccess {
        publication {
          id
        }
      }
    }
  }
`;
